import api from '../../../services/Api';
import { IAuditoriaSplitDespesasResultado } from '../interfaces/IAuditoriaSplitDespesas';

interface BuscarParams {
  empresaId: number;
  periodo: string | undefined;
}

export const AuditoriaSplitDespesasService = {
  buscarResultado: async (params: BuscarParams): Promise<IAuditoriaSplitDespesasResultado> => {
    const response = await api.get<IAuditoriaSplitDespesasResultado>(
      'auditoria-split-despesas/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
